module.exports = __webpack_public_path__ + "static/media/icon-save-white.78079bf0.svg";